import View from './view.vue'
import { ViewsOrderIsAccepted } from './views'
import isEstimated from '@caks/shared/middleware/isEstimated'

export default [
  {
    path: '/order',
    name: 'ViewOrder',
    component: View,
  },
  {
    path: '/cart/success',
    name: 'ViewsOrderIsAccepted',
    component: ViewsOrderIsAccepted,
  },
]
